export enum DeliveryConfirmation {
  Off = '',
  Signature = 'SIGNATURE',
  IndirectSignature = 'INDIRECT_SIGNATURE',
  NoSignature = 'NO_SIGNATURE',
  AdultSignature = 'ADULT_SIGNATURE'
}

export enum SpecialRates {
  MediaMail = 'USPS.MEDIAMAIL',
  LibraryMail = 'USPS.LIBRARYMAIL'
}

export enum HazmatReason {
  Ormd = 'ORMD',
  LimitedQuantity = 'LIMITED_QUANTITY',
  Lithium = 'LITHIUM'
}

export enum FedExPackages {
  Envelope = 'FedExEnvelope',
  Box = 'FedExBox',
  Pak = 'FedExPak',
  Tube = 'FedExTube',
  WeightedBox10 = 'FedEx10kgBox',
  WeightedBox25 = 'FedEx25kgBox',
  SmallBox = 'FedExSmallBox',
  MediumBox = 'FedExMediumBox',
  LargeBox = 'FedExLargeBox',
  ExtraLargeBox = 'FedExExtraLargeBox'
}

export enum UPSPackages {
  Letter = 'UPSLetter',
  ExpressBox = 'UPSExpressBox',
  kgBox25 = 'UPS25kgBox',
  kgBox10 = 'UPS10kgBox',
  Tube = 'Tube',
  Pak = 'Pak',
  SmallExpressBox = 'SmallExpressBox',
  MediumExpressBox = 'MediumExpressBox',
  LargeExpressBox = 'LargeExpressBox'
}

export enum UPSMailInnovationsPackages {
  BPMFlat = 'BPMFLAT',
  BPMParcel = 'BPMPARCEL',
  StandardFlat = 'FLAT'
}

export enum UspsPackages {
  Card = 'Card',
  Letter = 'Letter',
  Flat = 'Flat',
  FlatRateEnvelope = 'FlatRateEnvelope',
  FlatRateLegalEnvelope = 'FlatRateLegalEnvelope',
  FlatRatePaddedEnvelope = 'FlatRatePaddedEnvelope',
  Parcel = 'Parcel',
  IrregularParcel = 'IrregularParcel',
  SoftPack = 'SoftPack',
  SmallFlatRateBox = 'SmallFlatRateBox',
  MediumFlatRateBox = 'MediumFlatRateBox',
  LargeFlatRateBox = 'LargeFlatRateBox',
  LargeFlatRateBoxAPOFPO = 'LargeFlatRateBoxAPOFPO',
  RegionalRateBoxA = 'RegionalRateBoxA',
  RegionalRateBoxB = 'RegionalRateBoxB'
}

export const DeliveryConfirmationOptions = [
  { label: 'Signature Required', value: DeliveryConfirmation.Signature },
  { label: 'Adult Signature Required', value: DeliveryConfirmation.AdultSignature },
  { label: 'No Signature', value: DeliveryConfirmation.NoSignature },
  { label: 'Signature Required, Indirect allowed (FedEx only)', value: DeliveryConfirmation.IndirectSignature }
]

export const SpecialRatesOptions = [
  // for now, just support media mail. Library mail is specific to educational institutions. Leaving constant for clarity
  { label: 'Media Mail', value: SpecialRates.MediaMail }
]

export const HazmatReasonOptions = [
  { label: 'None', value: null },
  { label: 'ORM-D', value: HazmatReason.Ormd },
  { label: 'Limited Quantity', value: HazmatReason.LimitedQuantity },
  { label: 'Lithium Ion Batteries', value: HazmatReason.Lithium }
]

export interface PackageOptions {
  label: string
  value: string
}

export const FedExPackageOptions: PackageOptions[] = [
  { label: 'FedEx - Envelope', value: FedExPackages.Envelope },
  { label: 'FedEx - Box', value: FedExPackages.Box },
  { label: 'FedEx - Pak', value: FedExPackages.Pak },
  { label: 'FedEx - Tube', value: FedExPackages.Tube },
  { label: 'FedEx - 10kg Box', value: FedExPackages.WeightedBox10 },
  { label: 'FedEx - 25kg Box', value: FedExPackages.WeightedBox25 },
  { label: 'FedEx - Small Box', value: FedExPackages.SmallBox },
  { label: 'FedEx - Medium Box', value: FedExPackages.MediumBox },
  { label: 'FedEx - Large Box', value: FedExPackages.LargeBox },
  { label: 'FedEx - Extra Large Box', value: FedExPackages.ExtraLargeBox }
]

export const UPSPackageOptions: PackageOptions[] = [
  { label: 'UPS - Letter', value: UPSPackages.Letter },
  { label: 'UPS - Express Box', value: UPSPackages.ExpressBox },
  { label: 'UPS - 25 kg Box', value: UPSPackages.kgBox25 },
  { label: 'UPS - 10 kg Box', value: UPSPackages.kgBox10 },
  { label: 'UPS - Tube', value: UPSPackages.Tube },
  { label: 'UPS - Pak', value: UPSPackages.Pak },
  { label: 'UPS - Small Express Box', value: UPSPackages.SmallExpressBox },
  { label: 'UPS - Medium Express Box', value: UPSPackages.MediumExpressBox },
  { label: 'UPS - Large Express Box', value: UPSPackages.LargeExpressBox }
]
export const UPSMailInnovationsPackageOptions = [
  // Defaults to M4 (Parcel Select, Parcel Select Lightweight, BPM flats)  { label: 'UPS MI – BPM Flat', value: UPSMailInnovationsPackages.BPMFlat },
  // Defaults to M4 (Parcel Select, Parcel Select Lightweight, BPM flats) { label: 'UPS MI – Standard Flat', value: UPSMailInnovationsPackages.StandardFlat },
  { label: 'UPS MI – BPM Parcel', value: UPSMailInnovationsPackages.BPMParcel }
]

export const UspsPackageOptions: PackageOptions[] = [
  { label: 'USPS - Card', value: UspsPackages.Card },
  { label: 'USPS - Letter', value: UspsPackages.Letter },
  { label: 'USPS - Flat', value: UspsPackages.Flat },
  { label: 'USPS - Flat Rate Envelope', value: UspsPackages.FlatRateEnvelope },
  { label: 'USPS - Flat Rate Legal Envelope', value: UspsPackages.FlatRateLegalEnvelope },
  { label: 'USPS - Flat Rate Padded Envelope', value: UspsPackages.FlatRatePaddedEnvelope },
  { label: 'USPS - Parcel', value: UspsPackages.Parcel },
  { label: 'USPS - Irregular Parcel', value: UspsPackages.IrregularParcel },
  { label: 'USPS - SoftPack', value: UspsPackages.SoftPack },
  { label: 'USPS - Small Flat Rate Box', value: UspsPackages.SmallFlatRateBox },
  { label: 'USPS - Medium Flat Rate Box', value: UspsPackages.MediumFlatRateBox },
  { label: 'USPS - Large Flat Rate Box', value: UspsPackages.LargeFlatRateBox },
  { label: 'USPS - Large Flat Rate Box (APOFPO)', value: UspsPackages.LargeFlatRateBoxAPOFPO },
  { label: 'USPS - Regional Rate Box A', value: UspsPackages.RegionalRateBoxA },
  { label: 'USPS - Regional Rate Box B', value: UspsPackages.RegionalRateBoxB }
]
